import { useCallback, useContext, useDebugValue } from 'react';
import context from '.';

/** 
 * @return {[
 *  Date|null,
 *  (deliveryDate: Date) => void,
 * ]}
 */
const useDeliveryDate = () => {
  const { state, setState } = useContext(context);

  /**
   * Sets the delivery date
   * 
   * @type {(deliveryDate: Date) => void}
   */
  const setDeliveryDate = useCallback((deliveryDate) => {
    setState(ps => ({...ps, deliveryDate}))
  }, [setState]);

  useDebugValue(state.deliveryDate);
  return [state.deliveryDate, setDeliveryDate];
}

export default useDeliveryDate;